import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';
import { sectionType } from '@/views/website/products/components/description/common/types.js';
import { normalizeImgSrc } from '../utils';

export const buildProductReviews = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;
  const defaultAvatar = 'https://cdn.latteprint.com/latte/2025-08-22/1755856656227-49.jpg';

  const review_summary = suggestionFields?.content?.review_summary || {};
  const averageRating = review_summary?.rating_value || 4.8;
  const totalReviewers = review_summary?.total_reviewers || 3;
  const recommendCount = review_summary?.recommend_percent || 3;
  const reviews = (suggestionFields?.content?.reviews || []).map((review, index) => {
    return {
      fullName: review.author || 'Author ' + (index + 1),
      avatar: normalizeImgSrc(review.avatar_url || defaultAvatar),
      star: review.rating || 5,
      title: review.title || 'Great product!',
      content: review.content || 'Really love this item.',
      date: '', // string (tạm thời bị ẩn trong code)
      images: (review.photos || []).map(img => {
        return {
          src: img.url || '',
        };
      }),
    };
  });

  const fieldUpdate = {
    // ── Anchor & title ──────────────────────────────
    enableAnchor: true, // boolean
    title: 'Reviews Section', // string - data-title của section
    'title-review': 'Customer Reviews', // string - nội dung hiển thị tiêu đề
    'show-title-underline': true, // boolean

    // ── Tổng quan đánh giá ──────────────────────────
    'average-rating': averageRating, // string | number
    'total-reviewers': totalReviewers, // string | number
    'recommend-count': recommendCount, // string | number - dùng để tính progress bar

    // ── Màu sắc container & card ────────────────────
    'container-background': '#f9f9f9', // string (CSS color)
    'card-background': '#ffffff', // string (CSS color)
    'card-text-color': '#000000', // string (CSS color)
    'star-color': '#f0b100', // string (CSS color)

    // ── Nút Load more ───────────────────────────────
    'load-more-label': 'Load more', // string (default: 'Load more')
    'load-more-background': '#000000', // string (CSS color)
    'load-more-text-color': '#ffffff', // string (CSS color)
    buttonBorderColor: '#000000', // string (CSS color)
    buttonBorderRadius: 8, // number (px)
    'reviews-limit': 5, // number - số review hiển thị ban đầu

    // ── Danh sách reviews ───────────────────────────
    'body-reviews': reviews,
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionProductReviews(newSection.html, fieldUpdate, sectionType.sectionProductReviews),
  };
};
